import { Routes, RouterModule }  from '@angular/router';

import { TradesComponent } from './trade.component';
import { TradeDetailsComponent } from './details/details.component';

export const TradeRoutes: Routes = [
    {
        path: '',
        component: TradesComponent,
        children: [
            { path: '', redirectTo: '/app/icb/dashboard', pathMatch: 'full' },
            { path: 'details', component: TradeDetailsComponent }
        ]
    }
];

export const TradeRoutingModule = RouterModule.forChild(TradeRoutes);



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/trade/trade-routing.module.ts